import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class MerchantProfilesService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/merchant_profiles", { params: toSnakeCase(params) });
  }

  delete(id) {
    return securedAxiosInstance.delete(`/merchant_profiles/${id}`);
  }

  update(id, data) {
    return securedAxiosInstance.put(`/merchant_profiles/${id}`, { merchant_profile: toSnakeCase(data) });
  }

  new() {
    return securedAxiosInstance.get("/merchant_profiles/new");
  }

  create(params) {
    return securedAxiosInstance.post("/merchant_profiles", { merchant_profile: toSnakeCase(params) });
  }
}

export default new MerchantProfilesService();
